import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m21.035 13.965-7.07 7.07L42.93 50 13.965 78.965l7.07 7.07L50 57.072l28.965 28.965 7.07-7.07L57.07 50l28.965-28.965-7.07-7.07L50 42.93z" })
});
export default SvgCross;
